import { useState, useEffect } from "react";

import CalendarWCell from "./CalendarWCell";

import moment from "moment";

export default ({
  time,
  selectedDate,
  showWeekends,
  events,
  onClickEvent,
  onClickSlot,
}) => {
  const [days, setDays] = useState([]);

  const buildDay = () => {
    const date = moment(selectedDate);
    date.startOf("isoWeek");
    const wDays = [];
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    date.add(1, "days");
    wDays.push(moment(date));
    setDays(wDays);
  };

  useEffect(() => {
    buildDay();
  }, [events]);

  return (
    <div className="calendar-calendar-horas-ind">
      <div className="calendar-calendar-horas-ind-hora">
        <div className="calendar-calendar-horas-ind-hora-text">
          {moment(time, "HHmm").add(1, "hours").format("HH:mm")}
        </div>
        <div className="calendar-calendar-horas-ind-horas-separador"></div>
      </div>
      <div className="calendar-calendar-horas-ind-agenda">
        <CalendarWCell
          day={days.length > 0 ? days[0] : null}
          time={time}
          events={events}
          onClickEvent={onClickEvent}
          onClickSlot={onClickSlot}
        />
        <CalendarWCell
          day={days.length > 0 ? days[1] : null}
          time={time}
          events={events}
          onClickEvent={onClickEvent}
          onClickSlot={onClickSlot}
        />
        <CalendarWCell
          day={days.length > 0 ? days[2] : null}
          time={time}
          events={events}
          onClickEvent={onClickEvent}
          onClickSlot={onClickSlot}
        />
        <CalendarWCell
          day={days.length > 0 ? days[3] : null}
          time={time}
          events={events}
          onClickEvent={onClickEvent}
          onClickSlot={onClickSlot}
        />
        <CalendarWCell
          day={days.length > 0 ? days[4] : null}
          time={time}
          events={events}
          onClickEvent={onClickEvent}
          onClickSlot={onClickSlot}
        />
        {showWeekends && (
          <CalendarWCell
            day={days.length > 0 ? days[5] : null}
            time={time}
            events={events}
            onClickEvent={onClickEvent}
            onClickSlot={onClickSlot}
          />
        )}
        {showWeekends && (
          <CalendarWCell
            day={days.length > 0 ? days[6] : null}
            time={time}
            events={events}
            onClickEvent={onClickEvent}
            onClickSlot={onClickSlot}
          />
        )}
      </div>
    </div>
  );
};
